/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ExtraSpecialty = {
  type: 'all-of',
  contains: [{
    type: 'Specialty',
  }, {
    properties: {
      file: {
        type: 'File',
        isRequired: true,
      },
      toDelete: {
        type: 'boolean',
      },
    },
  }],
} as const;
